import { Injectable, Signal } from "@angular/core";
import { ActivatedRouteSnapshot, UrlTree } from "@angular/router";
import { Observable } from "rxjs";
import { FormService } from "../services/form.service";
import { PagingService } from "../services/paging.service";
import { Store } from "@ngrx/store";
import { BookingState, selectBookingState } from "../state";

@Injectable({
  providedIn: "root"
})
export class FormPositionGuard {
  private readonly bookingState: Signal<BookingState>;
  constructor(
    private formService: FormService,
    private pagingService: PagingService,
    private store: Store
  ) {
    this.bookingState = this.store.selectSignal(selectBookingState);
  }
  canActivate(
    route: ActivatedRouteSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    const currentStep = this.pagingService.formStepLocation;
    if (!this.bookingState().carInfo?.chassiNumber) {
      this.pagingService.navigateToStep(1);
      return false;
    }
    if (currentStep > 1 && !this.bookingState().selectedWorkshopSystems) {
      this.pagingService.navigateToStep(1);
      return false;
    }
    if (currentStep > 2 && !this.bookingState().selectedDealerNumber) {
      this.pagingService.navigateToStep(1);
      return false;
    }
    if (
      route.routeConfig.path == "complete" &&
      !this.formService.isEntireBookingValid
    ) {
      this.pagingService.navigateToStep(1);
      return false;
    }
    return true;
  }
}
